import(/* webpackMode: "eager", webpackExports: ["MotionLazy"] */ "/app/apps/web/src/components/animate/motion-lazy.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/progress-bar/progress-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/snackbar/snackbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/i18n-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/localization-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/core/locales/use-locales.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/font/google/target.css?{\"path\":\"src/fonts.ts\",\"import\":\"Wix_Madefor_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--default-font-family\"}],\"variableName\":\"fontWixMadeforDisplay\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/font/google/target.css?{\"path\":\"src/fonts.ts\",\"import\":\"Noto_Sans_Armenian\",\"arguments\":[{\"subsets\":[\"armenian\"],\"variable\":\"--default-font-family\"}],\"variableName\":\"fontNoto\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/sonner@2.0.7_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/sonner/dist/index.mjs");
